import React from 'react';
import ReactDOM from 'react-dom/client';
import RoutesIndex from './pages/routes'
import { BrowserRouter } from 'react-router-dom';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import keycloak from './keycloak/keycloak';
import { UserProvider } from './contexts/user.context';
import { KatoProvider } from './contexts/kato.context';
import './i18n';
import './index.scss'
import { SharedProvider } from './contexts/shared.context';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <ReactKeycloakProvider authClient={keycloak}>
    <BrowserRouter>
      <KatoProvider>
        <UserProvider>
          <SharedProvider>
            <RoutesIndex />
          </SharedProvider>
        </UserProvider>
      </KatoProvider>
    </BrowserRouter>
  </ReactKeycloakProvider >
);


